import { AppTermsAndConditions } from '../legals/TermsAndConditions.component'
import { ButtonInApp } from './ButtonInApp.component'
import { ContainerApp, ContentApp, FooterApp, HeaderApp } from './Layout.app'




export const TurnoTermsApp = () => {
	return (
		<ContainerApp>
			<HeaderApp title="Términos y Condiciones" />
			<ContentApp>
				<AppTermsAndConditions />
			</ContentApp>
			<FooterApp>
				<ButtonInApp
					label="Atrás"
					type="button"
					onClick={() => window.close()}
				/>
			</FooterApp>
		</ContainerApp>
	)
}